import { useQuery } from '@apollo/client';
import { ChevronRight } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

import { TotemMark } from '@/shared/brand/TotemLogo';

import { MY_PETS_QUERY } from './portal.gql';

/* eslint-disable @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-assignment */

export function PortalPetsPage(): JSX.Element {
  const { t } = useTranslation();
  const { data, loading, error } = useQuery(MY_PETS_QUERY, { fetchPolicy: 'cache-and-network' });
  const pets: any[] = data?.myPets ?? [];

  return (
    <div className="space-y-3">
      <h2 className="font-display text-lg font-bold tracking-tight">{t('portal.nav_pets')}</h2>
      {loading && pets.length === 0 ? (
        <p className="text-muted-foreground text-sm">{t('common.loading')}</p>
      ) : error && pets.length === 0 ? (
        <p className="text-destructive text-sm">{t('portal.load_error')}</p>
      ) : pets.length === 0 ? (
        <div className="flex flex-col items-center gap-2 py-10 text-center">
          <TotemMark className="text-muted-foreground/40 h-10 w-auto" aria-hidden />
          <p className="text-muted-foreground text-sm">{t('portal.no_pets')}</p>
        </div>
      ) : (
        <ul className="space-y-2">
          {pets.map((p) => (
            <li key={p.id}>
              <Link
                to={`/portal/pets/${p.id}`}
                className="bg-card hover:border-primary/40 flex items-center justify-between gap-2 rounded-lg border p-4 transition-colors"
              >
                <div className="min-w-0">
                  <p className="font-medium">{p.name}</p>
                  <p className="text-muted-foreground truncate text-xs">
                    {[p.species, p.breed].filter(Boolean).join(' · ') || '—'}
                  </p>
                </div>
                <ChevronRight className="text-muted-foreground h-5 w-5" aria-hidden />
              </Link>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
